import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaSpacerComponent} from './la-spacer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaSpacerComponent],
  exports: [LaSpacerComponent]
})
export class LaSpacerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaSpacerModule,
      providers: []
    }
  }
}
